import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import './index.css';

const Toast = (props) => {
  const { toastList, position, autoDelete, dismissTime, t } = props;
  const [list, setList] = useState(toastList);

  useEffect(() => {
    setList([...toastList]);
    console.log(toastList, position, autoDelete, dismissTime);
  }, [toastList]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && toastList.length && list.length) {
        deleteToast(toastList[0].id);
      }
    }, dismissTime);

    return () => {
      clearInterval(interval);
    };
  }, [toastList, autoDelete, dismissTime, list]);

  const deleteToast = (id) => {
    const listItemIndex = list.findIndex((e) => e.id === id);
    const toastListItem = toastList.findIndex((e) => e.id === id);
    list.splice(listItemIndex, 1);
    toastList.splice(toastListItem, 1);
    setList([...list]);
  };

  return (
    <>
      <div className={`notification-container ${position}`}>
        {list.map((toast, i) => (
          <div
            key={i}
            className={`d-flex flex-row notification toast ${position}`}
            style={{ backgroundColor: '#ffffff' }}
          >
            <div className="d-flex flex-column" style={{ width: '242px' }}>
              <p className="notification-title p-2">{toast.title}</p>
              <p className="notification-message p-2">{toast.description}</p>
            </div>
            <div className="d-flex flex-column" style={{ width: '87px' }}>
              <span
                className="content-read fz-12 notification-action"
                onClick={() => deleteToast(toast.id)}
              >
                {t('txt-ignore')}
              </span>
              <span className="content-read fz-12 notification-action font-weight-bold">
                {t('txt-detail')}
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

Toast.propTypes = {
  toastList: PropTypes.array.isRequired,
  position: PropTypes.string,
  autoDelete: PropTypes.bool,
  dismissTime: PropTypes.number,
};

export default translate('translations')(Toast);
